import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgCn48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  "aria-label": "China",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#e7e7e7",
  stroke: "#e7e7e7",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#de2910",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffde00",
  d: "m6.12 6.24 1.64 5.06-4.31-3.13h5.32l-4.3 3.13zm5.02-.86L11 7.15l-.92-1.52 1.64.69-1.72.4zm2.17 2.07L12.48 9l-.25-1.76 1.24 1.28-1.75-.31zm.21 3.13-1.4 1.09.49-1.7.6 1.66-1.47-1zm-2.41 1.31L11 13.66l-1-1.48 1.66.63-1.66.47z"
}));

export { SvgCn48Rounded as default };
//# sourceMappingURL=Cn48Rounded.js.map
